import React from "react";
import { motion } from "framer-motion";

const TERMS_TEXT = `TERMS & CONDITIONS
Please read these Terms & Conditions carefully before using Study Partners. By accessing or using our platform, you agree to comply with these terms.
If you do not agree, do not use the App.

 1.  About Study Partners
Study Partners is an educational and collaborative learning platform designed to help students discuss subjects, connect with study partners (Hosts), and prepare for academic and competitive examinations.

App Name: Study Partners
Owner: Urmila Chouhan
Email: Medicalstudent204@gmail.com
Established: 2026
Effective From: 05/02/2026

 2. ELIGIBILITY & AGE DECLARATION
Only Class 9 and above students may use the App
Includes:
School students (Class 9–12)
College students
Competitive, entrance, and professional exam aspirants
Users below 18 years must have parent/guardian consent
⚠️ The App does not verify age or consent.
Any false declaration is the sole legal responsibility of the user.

 3. LEGALLY BINDING AGREEMENT
By downloading, registering, accessing, or using the Study Partner App, you confirm and agree that:
You have read and fully understood these Terms
You accept them voluntarily and knowingly
You are legally competent to agree
You accept all risks related to using the App
If you do not agree, do not use the App.

 4. INTERMEDIARY STATUS & SAFE HARBOUR (CRITICAL)
Study Partner operates strictly as a technology intermediary under the Information Technology Act, 2000 and applicable rules.
Therefore:
The App does not create, edit, verify, control, or endorse user content
All chats, messages, profiles, and interactions are user-generated third-party content
The Owner enjoys Safe Harbour protection under Section 79 of the IT Act
Legal responsibility lies solely with the user

 5. NATURE OF THE APP (NO EDUCATIONAL ROLE)
The App:
Is NOT a school, college, university, or coaching institute
Is NOT a teacher, tutor, mentor, or counselor
Does NOT provide education, instruction, or guarantees
Does NOT guarantee marks, ranks, results, or success
The App only:
Helps students find study partners
Provides chat functionality after mutual consent

6. USER DATA & MATCHING LOGIC
The App may collect:
Mobile number (OTP login)
Approximate location
Age and gender
Up to 5 exam names
Study preferences
Matching is based on:
Exam selection
Nearby location
Mutual request & acceptance
The App does not guarantee compatibility, safety, or accuracy of users.

 7. ASSUMPTION OF ALL RISKS
Study Partners operates as a technology platform facilitating peer-to-peer interactions. While we implement reasonable safety measures and platform policies, users are responsible for their own interactions and conduct on the platform.

 8. NO DUTY TO MONITOR OR INTERVENE
Study Partners respects user privacy and does not actively monitor private chats. However, we reserve the right to review reported misuse, investigate violations of our policies, and take appropriate action including warning, suspension, or permanent account termination to ensure user safety and platform integrity.

 9. ACCEPTABLE USER CONDUCT WITH HOSTS
Users must adhere to these guidelines when interacting with Hosts to ensure respectful, safe, and constructive experiences:
Engage Respectfully: Users are expected to communicate with Hosts politely and respectfully, refraining from any language or behavior that could be perceived as disrespectful or offensive.
Maintain Professional Boundaries: Personal questions or topics that may infringe on the privacy or comfort of the Host are not permitted. Users should engage with Hosts in a manner consistent with Study Partners community standards.
Follow Platform Guidelines: Users must comply with all Study Partners rules, including content standards and moderation guidelines, when interacting with Hosts.

 10. PROHIBITED ACTIVITIES
Users must NOT:
Abuse, threaten, harass, or defame
Share obscene, sexual, hateful, or illegal content
Share exam leaks, piracy, or copyrighted material
Use the App for dating, fraud, or promotion
Impersonate teachers or institutions
Misuse personal data of others.

Harassment, abusive language, threats, or intimidation.
Discrimination including racism, sexism, hate speech, or homophobia.
Use of offensive, explicit, or inappropriate language.
Requesting personal contact details of Hosts.
Soliciting unlawful, explicit, or illegal content.
Requesting off-platform communication.
Spamming or repetitive messaging.
Sharing irrelevant or disruptive content.

Harassment and Abusive Behavior

Users must not engage in any form of harassment or abusive behavior towards Hosts. This includes, but is not limited to:

Harassment: Repeated or unwanted contact, including messaging or attempts to engage the Host outside of Platform rules.
Abusive Language: Use of profanity, insults, or other derogatory language towards Hosts.
Intimidation or Threats: Any form of threatening or intimidating language or actions toward Hosts is prohibited.
Discrimination and Offensive Language

Discriminatory Conduct: Users must not engage in or promote any discriminatory behavior, including but not limited to, racism, sexism, homophobia, or hate speech targeting the Host or others on the Platform.
Offensive Language: The use of offensive language, including slurs, sexual innuendo, or comments of an explicit nature, is strictly prohibited.
Inappropriate Content Requests

Requesting Personal or Sensitive Information: Users may not ask Hosts to share personal information such as their phone number, address, or any other private details.
Soliciting Unlawful Content: Requests for any content that is illegal, explicit, obscene, or otherwise prohibited by law or the Platform’s guidelines are strictly forbidden.
Soliciting Off-Platform Interactions: Users must not request that Hosts engage in any interaction outside of Study Partners.
Spamming and Disruptive Behavior

Repeated Messaging: Repetitive or spammy messages that interrupt the Host or disrupt the conversation are prohibited.
Off-Topic or Irrelevant Content: Users must keep their interactions relevant to the context of the conversation. Off-topic content that disrupts the flow of discussion is not allowed.

Violation may result in:
Immediate account termination
Permanent ban
Data preservation
Cooperation with law enforcement



 11. LIMITATION OF LIABILITY
To the maximum extent permitted under applicable law, Study Partners’ liability shall be limited and reasonable. We shall not be liable for indirect, incidental, consequential, user-generated, or interaction-related damages arising from the use of the platform.
This includes:
Academic loss
Mental stress
Harassment by users
Wrong information
Data loss or cyber incidents

 12. USER RESPONSIBILITY AND LIABILITY
Users are solely responsible for their actions and communications on the Platform.

Acceptance Consent
By using the Study Partners Mobile App, you agree to all these Terms and Conditions.

Acceptance of Consequences
By using the Platform, Users agree to bear the consequences of any violations of these Terms, including the potential loss of account access or other penalties imposed by the Study Partners.

Liability for Damages

Users agree to indemnify and hold the Study Partners harmless from any damages resulting from violations of these Interaction Terms, including any harm caused to Hosts, other Users, or the Study Partners.

 13. CONTENT STANDARDS FOR USER INTERACTIONS WITH HOSTS:
Users must adhere to Study Partners content standards while interacting with Hosts. Violations of content standards may result in penalties, including account suspension. Content shared during interactions with Hosts must meet the following criteria:

Compliance with Legal Standards

No Illegal Content: Users must not share content that is illegal, including anything that is obscene, defamatory, or otherwise prohibited by law.
Respect for Host Safety and Well-being: Any content shared should not endanger the safety, privacy, or well-being of Hosts or other Platform users.
Community Standards for Content

No Promotion of Harmful Behavior: Users must not engage in or promote content that encourages violence, hatred, self-harm, or other harmful behaviors.
Constructive Engagement: Users are encouraged to maintain constructive and respectful interactions, ensuring that the Platform remains a safe space for all users and Hosts.

 14. DISCLAIMERS AND LIMITATION OF LIABILITY:                                        Study Partners provides a Platform for social interactions but makes no guarantees or representations regarding individual Host interactions.    
 15. Intellectual Property
 All content and materials provided through the Study Partner's App, including but not limited to text, graphics, logos, images, and software, are the property of Study Partner's and are protected by intellectual property laws.
Users are granted a limited, non-exclusive, non-transferable license to use the App for its intended purpose. Users shall not reproduce, distribute, or modify any content from the App without the prior written consent of Study Partners.

 16. Disclaimer of Warranties

The Study Partners App is provided "as is," and Study Partners makes no warranties or representations regarding its accuracy, reliability, or suitability for any purpose.

 17. TERMINATION WITHOUT RIGHTS
Study Partner may:
Suspend or delete any account
At any time
Without notice
Without explanation
Without compensation

 18. PRIVACY AND DATA SECURITY IN INTERACTIONS:
PRIVACY AND DATA SECURITY IN
INTERACTIONS

Respecting Host Privacy: Users are not permitted to ask for or attempt to obtain any private information about Hosts beyond what they have shared publicly on the Platform.
No Unauthorized Recording or Distribution: Users are prohibited from recording, screenshotting, or otherwise capturing interactions with Hosts without explicit permission. Sharing Host interactions on other platforms without consent is a violation of these Terms.
No Unauthorized Recording or Distribution: Users are prohibited from recording, screenshotting, or otherwise capturing interactions with Hosts without explicit permission. Sharing Host interactions on other platforms without consent is a violation of these Terms.

 19. CHILD SAFETY
We are committed to protecting children from online harm. We have implemented the following measures to ensure a safe and appropriate experience for all users:
Standards Against Child Sexual Abuse and Exploitation (CSAE):
We adhere to industry best practices and published standards regarding the prevention and mitigation of CSAE. This includes:
Prohibiting any content or behavior that exploits, abuses, or endangers children. This includes, but is not limited to, child sexual abuse material (CSAM), child exploitation, and the solicitation of minors.

 20. Modification & Updates to Terms and Conditions
Study Partners reserves the right to update, modify, amend, or replace these Terms and Conditions at any time, at its sole discretion. 
Any updates will become effective immediately upon being published within the Study Partners application or on its official platform. Users are responsible for reviewing the Terms and Conditions periodically to stay informed of any changes.
Your continued access to or use of the Study Partners app after the revised Terms and Conditions are posted shall constitute your acceptance of and agreement to the updated terms. If you do not agree with any part of the modified Terms and Conditions, you must discontinue use of the app and its services.

 21. GRIEVANCE REDRESSAL MECHANISM:
For concerns or complaints related to interactions with Hosts, Users may contact the Grievance Officer. Our Grievance Officer is available to address all user concerns regarding Platform usage and Host interactions.

Grievance Officer Contact Details:
Vijay Chouhan
Email: Medicalstudent204@gmail.com
Address: Rehti district Sehore, Madhya Pradesh 466446

We will respond to all complaints.

 22. INDEMNITY
You agree to fully indemnify and defend Urmila Chouhan from:
Legal notices
Police complaints
FIRs
Court cases
Legal costs and penalties
Arising from your actions or content.

 23. GOVERNING LAW & JURISDICTION
Governed by laws of India
Exclusive jurisdiction of Indian courts only.

 24. Educational Purpose 
Study Partners is an educational platform. We do not guarantee exam success, academic performance, rankings, or results.

 25. No Gambling or Financial Activities
The Platform does not promote gambling, betting, real-money gaming, or financial investment schemes.

 26. Third-Party Services
The Platform may use trusted third-party services including cloud hosting, authentication services, analytics tools, and SMS OTP providers.

27. Consent & Declaration
By clicking “I AGREE & CONTINUE”, 
I voluntarily, knowingly, and legally confirm the following:
1. I am a student of Class 9 or above.
2. If I am below 18 years, I confirm I have valid parent/guardian consent.              3. I understand Study Partners is only a technology platform, not a school, teacher, tutor, or coaching institute.
4.  I understand the app does NOT provide education, teaching, guidance, counseling, or exam guarantees.
5. I understand all chats and discussions are peer-to-peer, user-generated content only.
6. I accept that study advice from users may be incorrect, incomplete, or harmful.
7. I agree that all academic decisions and outcomes are entirely my responsibility.
8. I understand the app does not verify users, exams, study content, or accuracy of information.
9. I acknowledge the app works only as an intermediary under Indian IT laws.
10. I agree that Study Partners and its owner do not control or endorse any user content.                                                     11.  I consent to the use of my mobile number for OTP login.
12. I consent to the use of my approximate location for nearby matching.
13. I consent to share my age, gender, and up to 5 exam names for matching purposes.
14.  I understand matching happens only by user request and mutual acceptance.
15.  I accept that the app does not guarantee safety, compatibility, or behavior of any user.
16.  I agree not to misuse the app for abuse, dating, fraud, illegal activity, or harassment.
17.  I understand my account may be suspended or permanently deleted at any time without notice.
18.  I accept that any misuse may be reported to authorities if required by law.
19.  I agree that all legal responsibility for my actions lies with me, not the app owner.
20.  I agree that the owner's legal liability is limited and reasonable. To the maximum extent permitted under applicable law, Study Partners' liability shall be limited and reasonable. We shall not be liable for indirect, incidental, consequential, user-generated, or interaction-related damages arising from the use of the platform.
21.  I waive all claims against the app and its owner arising from my use of the platform.
22. I confirm that I am Class 9 or above, have parental consent if under 18, and agree to the Terms & Privacy Policy.
 23.   I allow the app to use my approximate location for matching study partners.
24. I understand Study Partners acts as an intermediary platform and does not control or endorse user-generated content, and users are solely responsible for their communications and interactions on the platform.
25.  I confirm that I have read, understood, and voluntarily agreed to all Terms, Privacy Policy, Disclaimers, and Community Guidelines.

I agree to Study Partners Terms & Conditions and Privacy Policy. I understand that Study Partners acts as an intermediary platform and does not control or endorse user-generated content, and users are solely responsible for their communications and interactions on the platform.`;

const TermsConditions = () => {
  const [, ...termsLines] = TERMS_TEXT.split("\n");
  const termsBody = termsLines.join("\n");

  return (
    <section className="bg-[#C8F1F9] min-h-screen px-6 py-20">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-4xl mx-auto bg-white/80 backdrop-blur-xl rounded-3xl shadow-[0_25px_80px_rgba(0,0,0,0.15)] p-10 md:p-14 text-gray-800"
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-4xl md:text-5xl font-extrabold text-center text-[#3498db] mb-12"
        >
          Terms & Conditions
        </motion.h1>
        <pre className="whitespace-pre-wrap break-words text-sm md:text-base leading-relaxed font-sans">
          {termsBody}
        </pre>
      </motion.div>
    </section>
  );
};

export default TermsConditions;
